import { multi, withDependencies } from '@wix/thunderbolt-ioc'
import type { ImportMap } from './types'
import type { IAppWillMountHandler, ImportMapProvider } from '@wix/thunderbolt-symbols'
import { ImportMapProviderSymbol } from '@wix/thunderbolt-symbols'
import { ImportMapSymbol } from './symbols'

export const PublicAppWillMountHandler = withDependencies(
	[ImportMapSymbol, multi(ImportMapProviderSymbol)] as const,
	(importMap: ImportMap, importMapProviders: Array<ImportMapProvider>): IAppWillMountHandler => {
		return {
			appWillMount: () => {
				const allDependencies = importMapProviders
					.map((provider) => provider.provideImportMap())
					.reduce((acc, curr) => {
						return { ...acc, ...curr }
					}, {})
				importMap.updateAndCommit(allDependencies)
			},
		}
	}
)
